module.exports = __webpack_public_path__ + "media/images/star-1-78b90897dea93cdaead0528c07d21458.png";